import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Snackbar,
  Alert,
  IconButton,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import fetchcity from "../../common/fetchcity";
import toast from "react-hot-toast";
// import axios from "axios";

const Updatepeakseasons = ({ setActiveItem }) => {
  let rentalType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.rentalTypes;
  delete rentalType?.inverted
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [form, setForm] = useState({
    name: "",
    peakRentalCharges: "",
    startDate: null,
    endDate: null,
    cityId: "",
    isActive: true,
    isPriceDrop : false,
    forRentalType : null
  });

  const [cities, setCities] = useState(null);

  useEffect(() => {
    fetchcity().then((response) => {
      if (response) {
        setCities(response);
      }
    });
  }, []);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const formatLocalISO = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const handleDateChange = (field, value) => {
    if (!value) return;

    const date = new Date(value); // from <input type="date">
    if (field === "startDate") date.setHours(0, 0, 0, 0);
    if (field === "endDate") date.setHours(23, 59, 0, 0);

    setForm((prev) => ({
      ...prev,
      [field]: formatLocalISO(date), // <-- local datetime, no UTC shift
    }));
  };

  const addPeakSeasonDetails = async () => {
    if (
      !form.name ||
      !form.peakRentalCharges ||
      !form.startDate ||
      !form.endDate ||
      !form.cityId || !form.forRentalType
    ) {
      return toast.error("Please fill all the field for peak season", {
      position: "top-center",
      style: {
        background: "white", // override background
        color: "red",
        fontWeight: "medium",        
      },
    });
    }

    try {
      const response = await fetch(`${apiUrl}/api/peakseasons`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          name: form?.name,
          isActive: form?.isActive,
          startDate: form?.startDate,
          endDate: form?.endDate,
          cityId: form?.cityId,
          peakRentalCharges: form?.peakRentalCharges,
          isPriceDrop : form?.isPriceDrop,
          forRentalType : form?.forRentalType
        }),
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setActiveItem("View Peak Season");
        setForm({
          name: "",
          peakRentalCharges: "",
          startDate: null,
          endDate: null,
          cityId: "",
          isActive: true,
          isPriceDrop : false,
          forRentalType : null
        });
        toast.success("Peak Created Successfully")
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error during approval:", error);
    }
  };

  return (
    <div className="mt-8">
      <div className="my-4 text-xl md:text-2xl font-bold">
        <h1>Add Peak Season Details</h1>
      </div>
      <div className="space-y-6 mt-8">
        <div className="flex flex-col sm:flex-row gap-4">
          <FormControl fullWidth>
            <InputLabel id="rental-type-label">Rental Type</InputLabel>
            <Select
              labelId="rental-type-label"
              value={form.forRentalType}
              onChange={(e) => handleChange("forRentalType", e.target.value)}
              label="rental-type"
            >
              {rentalType &&
                Object.entries(rentalType).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Name"
            required
            value={form.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
          <TextField
            fullWidth
            type="number"
            label="Peak Rental Charges"
            required
            value={form.peakRentalCharges}
            onChange={(e) => handleChange("peakRentalCharges", e.target.value)}
          />

          <FormControl fullWidth>
            <InputLabel id="city-label">City</InputLabel>
            <Select
              labelId="city-label"
              value={form.cityId}
              onChange={(e) => handleChange("cityId", e.target.value)}
              label="City"
            >
              {cities &&
                Object.entries(cities).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={form.isActive}
              onChange={(e) => handleChange("isActive", e.target.value)}
            >
              <MenuItem value={true}>Active</MenuItem>
              <MenuItem value={false}>Inactive</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Price Status</InputLabel>
            <Select
              value={form.isPriceDrop}
              onChange={(e) => handleChange("isPriceDrop", e.target.value)}
            >
              <MenuItem value={false}>Increased</MenuItem>
              <MenuItem value={true}>Decreased</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <TextField
            fullWidth
            type="date"
            label="Start Date"
            value={form.startDate ? form.startDate.split("T")[0] : ""}
            onChange={(e) => handleDateChange("startDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            fullWidth
            type="date"
            label="End Date"
            value={form.endDate ? form.endDate.split("T")[0] : ""}
            onChange={(e) => handleDateChange("endDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </div>
      </div>
      <div className="flex justify-center mt-10">
        <button
          onClick={() => {
            addPeakSeasonDetails();
          }}
          class="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border-[1px] border-slate-500 text-white font-medium group"
        >
          <div class="relative overflow-hidden">
            <p class="group-hover:-translate-y-7 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
              Add Season
            </p>
            <p class="absolute top-7 left-0 group-hover:top-0 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
              Add Season
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Updatepeakseasons;
